import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'LuxKit/Typography/Heading'
import QuotationMarkEndSvg from './QuotationMarkEndSvg'
import QuotationMarkStartSvg from './QuotationMarkStartSvg'
import { FormattedMessage, useIntl } from 'react-intl'

const ReviewText = styled(Heading)`
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  
  &.fade-out {
    opacity: 0;
  }
`

const TravellerContainer = styled(Group)`
  max-width: ${rem(600)};
  flex: 1;
`
const QuotationMark = styled(Group)`
  max-width: ${rem(50)};
`

const REVIEW_DURATION = 5000

function TripLandingPageWhatOurTravellersSay() {
  const intl = useIntl()
  const [reviewIndex, setReviewIndex] = useState(0)
  const [isFading, setIsFading] = useState(false)

  const whatOurTravellersSay = useMemo(() => [
    intl.formatMessage({
      id: 'ep4yDSDZI4Z0VO83emFq',
      defaultMessage: 'The trip planner made organising our holiday a breeze. Everything was so intuitive and easy to use! It saved us hours of planning',
      description: 'Review from traveller about trip planner ease of use',
    }),
    intl.formatMessage({
      id: 'FosksOO0D_e9xIvy3Vh-',
      defaultMessage: 'I loved being able to add hotels, tours, and experiences all in one place. It was such a seamless experience.',
      description: 'Review from traveller about seamless experience in the trip planner',
    }),
    intl.formatMessage({
      id: 'RTzxF6PdNEXOu01u19qY',
      defaultMessage: 'Planning my Bali adventure was so much smoother with all the options in one tool. Very glad I got to do this so quickly!',
      description: 'Review from traveller about planning efficiency in the trip planner',
    }),
    intl.formatMessage({
      id: '1x6Lcx2T8GzdsZuIwXay',
      defaultMessage: 'I loved the flexibility to customise every detail of my itinerary. It made planning my trip feel effortless and actually fun!',
      description: 'Review from traveller about customization flexibility',
    }),
    intl.formatMessage({
      id: 'wU8w_f_lxCj0LCVCHd9U',
      defaultMessage: 'This saved me so much time. I had my whole holiday sorted—flights, stays, and activities—all in one sitting, without any hassle!',
      description: 'Review from traveller about time savings in the flights flow',
    }),
    intl.formatMessage({
      id: 'aAlI_nhjVtyKTYZcr6Ku',
      defaultMessage: 'It’s a fantastic way to centralise different hotels and activities quickly. So glad this app is available on the website.',
      description: 'Testimonial review from a traveller about the trip planner centralization feature',
    }),
    intl.formatMessage({
      id: 'DN2KG8Hd7PCbLsGdKAfX',
      defaultMessage: 'The app worked seamlessly and even encouraged me to research some great hidden gems. I now have a solid plan when travelling.',
      description: 'Review from traveller about app functionality in the trip planner',
    }),
    intl.formatMessage({
      id: '5N4oqzGAftcqBDTnPTnh',
      defaultMessage: 'I highly recommend it, especially for families. It was so simple to keep everyone’s plans organised and have a mixture of different activities.',
      description: 'Review from traveller recommending for families in the trip planner',
    }),
    intl.formatMessage({
      id: '8Gxavw5kkemOXRVsFvkU',
      defaultMessage: 'This is the a great trip planning tool I’ve used. I already told my friends to use this for their trips as well!',
      description: 'Review from traveller recommending to friends in the trip planner',
    }),
  ], [intl])

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true)

      setTimeout(() => {
        setReviewIndex((reviewIndex + 1) % whatOurTravellersSay.length)
        setIsFading(false)
      }, 500)
    }, REVIEW_DURATION)

    return () => clearInterval(interval)
  }, [reviewIndex, whatOurTravellersSay.length])

  const currentReview = whatOurTravellersSay[reviewIndex]

  return (
    <Sheet paletteType="inverse" padding="64 0">
      <LayoutContainer>
        <Group direction="vertical" gap={32}>
          <HeadingTextBlock variant="heading3" align="center">
            <FormattedMessage
              id="BqIKbQnq0m41JyxGgiSm"
              defaultMessage="What our travellers say"
              description="Heading for what our travellers say section in the traveller form"
            />
          </HeadingTextBlock>
          <Group direction="horizontal" horizontalAlign="center">
            <TravellerContainer direction="vertical" gap={16} horizontalAlign="center" tabletDirection="horizontal" tabletHorizontalAlign="space-between">
              <QuotationMark direction="horizontal" horizontalAlign="center">
                <QuotationMarkStartSvg />
              </QuotationMark>
              <ReviewText
                variant="heading4"
                align="center"
                className={isFading ? 'fade-out' : ''}
              >
                {currentReview}
              </ReviewText>
              <QuotationMark direction="horizontal" horizontalAlign="center">
                <QuotationMarkEndSvg />
              </QuotationMark>
            </TravellerContainer>
          </Group>
        </Group>
      </LayoutContainer>
    </Sheet>
  )
}

export default TripLandingPageWhatOurTravellersSay
